import webIcon from '../../Assets/images/icons/web.png';
import mobileIcon from '../../Assets/images/icons/mobileDev.png';
import designIcon from '../../Assets/images/icons/design.png';

export const SKILLS = [
	{ name: 'Web Dev', icon: webIcon },
	{ name: 'Mobile Dev', icon: mobileIcon },
	{ name: 'UI Design', icon: designIcon },
];
